import React, { useState } from "react";
import DataTable from "../../../Components/UI/table/DataTable";
import { useQuery } from "react-query";
import StatusBadge from "../../../Components/UI/statusBadge";
import TableActions from "../../../Components/UI/table/TableActions";
import { deleteCoupon, updateCoupon } from "../../../MyApi/coupons";
import { getCouponsAPI } from "../../../MyApi/coupons";
import AddModalCoupon from "../addmodalciopon";
import Can from "../../../utils/can";
import { formatPrice } from "../../../utils/formatPrice";
import FilterBar from "../../../Components/UI/filterbar";
import i18next from "i18next";

const CouponsTab = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [couponModalMode, setCouponModalMode] = useState("create");
  const [couponId, setCouponId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    search: "",
    store_id: "",
    is_active: "",
    date: "",
    category_id: "",
  });

  const handleShowCoupon = (id) => {
    setCouponId(id);
    setCouponModalMode("show");
    setIsModalOpen(true);
  };

  const handleEditCoupon = (id) => {
    setCouponId(id);
    setCouponModalMode("edit");
    setIsModalOpen(true);
  };

  const couponsColumns = [
    { label: "اسم الكوبون", accessor: "name" },
    { label: "كود الكوبون", accessor: "code" },
    { label: "النوع", accessor: "discount_type" },
    {
      label: "الخصم",
      render: (row) => (
        <div className="text-green">
          {row.discount_type === "fixed"
            ? formatPrice(row.currency_factor, row.discount_amount)
            : row.discount_amount}
          {row.discount_type === "percentage" ? "%" : ""}
        </div>
      ),
    },
    { label: "تاريخ البداية", accessor: "start_date" },
    { label: "تاريخ النهاية", accessor: "end_date" },
    { label: "عدد الكوبونات", accessor: "usage_limit" },
    { label: "عدد الكوبونات لكل مستخدم", accessor: "usage_limit_per_user" },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          show={() => handleShowCoupon(row.id)}
          viewPermission={"view_coupon"}
          edit={() => handleEditCoupon(row.id)}
          editPermission={"update_coupon"}
          deleteFn={deleteCoupon}
          deletePermission={"delete_coupon"}
          id={row.id}
          queryKey={"getCoupons"}
          is_active={row.is_active}
          togglePermission={"update_coupon"}
          toggleMutationKey={"toggle_coupon"}
          toggleFn={(id, status) =>
            updateCoupon(id, {
              is_active: status,
              _method: "PUT",
              lang: i18next.language,
            })
          }
        />
      ),
    },
  ];

  const {
    data: couponsData,
    isLoading: couponsLoading,
    refetch,
    error,
  } = useQuery(
    ["getCoupons", currentPage, filters],
    () => getCouponsAPI(filters.store_id, currentPage, filters),
    {
      keepPreviousData: true,
    },
  );

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleResetFilters = (resetFilters) => {
    setFilters(resetFilters);
    setCurrentPage(1);
  };

  const coupons = couponsData?.data?.coupons || [];
  const total = couponsData?.data?.pagination?.total || 0;
  const last_page = couponsData?.data?.pagination?.last_page || 0;

  return (
    <>
      <Can permission={"view_coupon"}>
        <FilterBar
          filters={filters}
          setFilters={setFilters}
          onFilterChange={handleFilterChange}
          onResetFilters={handleResetFilters}
          filtersConfig={{
            search: true,
            store: true,
            categories: true,
            date: true,
            is_active: true,
          }}
          placeholder="بحث بالاسم أو الكود"
        />
        <DataTable
          columns={couponsColumns}
          data={coupons}
          title="كوبونات الخصم"
          actionLabel="إضافة كوبون جديد"
          onAddClick={() => {
            setCouponModalMode("create");
            setCouponId(null);
            setIsModalOpen(true);
          }}
          isLoading={couponsLoading}
          createPermission={"create_coupon"}
          totalItems={total}
          itemsPerPage={last_page}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          error={error}
          onRetry={() => refetch()}
        />
      </Can>
      {isModalOpen && (
        <AddModalCoupon
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setCouponModalMode("create");
            setCouponId(null);
          }}
          refetch={refetch}
          mode={couponModalMode}
          couponId={couponId}
        />
      )}
    </>
  );
};

export default CouponsTab;
